<template>
  <div>
    <b-overlay :show="show">
      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("oblast") }}: </span>
              <span style="font-weight:bolder">
                {{ buyerInfo.OblastName }}
              </span>
            </b-list-group-item>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("region") }}: </span>
              <span style="font-weight:bolder">
                {{ buyerInfo.RegionName }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col>
          <b-list-group>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
            >
              <span> {{ $t("buyername") }}: </span>
              <span style="font-weight:bolder">
                {{ buyerInfo.BuyerName }}
              </span>
            </b-list-group-item>
            <b-list-group-item
              variant="info"
              class="d-flex justify-content-between"
              ><span> {{ $t("buyertin") }}: </span>
              <span style="font-weight:bolder">
                {{ buyerInfo.BuyerINN }}
              </span></b-list-group-item
            >
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-tabs pills>
            <b-tab :title="$t('category')">
              <b-row class="mt-3">
                <b-col>
                  <b-table
                    head-row-variant="info"
                    :fields="fields1"
                    :items="data.UzexListByProductCategory"
                    bordered
                    small
                    sticky-header="60vh"
                    no-border-collapse
                  >
                    <template #cell(totalcost)="{item}">
                      {{
                        $options.filters.currency(item.totalcost, {
                          symbol: "",
                          fractionCount: 0
                        })
                      }}
                    </template>
                    <template v-slot:custom-foot>
                      <b-tr>
                        <b-td variant="info" class="text-center"
                          ><b> {{ $t("Total") }} : </b>
                        </b-td>
                        <b-td variant="info" class="text-right"
                          ><span style="white-space:nowrap;font-weight:bolder">
                            {{
                              $options.filters.currency(total.quantityCat, {
                                symbol: "",
                                fractionCount: 0
                              })
                            }}
                          </span></b-td
                        >
                        <b-td variant="info" class="text-right"
                          ><span style="white-space:nowrap;font-weight:bolder">
                            {{
                              $options.filters.currency(total.sumCat, {
                                symbol: "",
                                fractionCount: 0
                              })
                            }}
                          </span>
                        </b-td>
                      </b-tr>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('provider')">
              <b-row class="mt-3">
                <b-col>
                  <b-table
                    head-row-variant="info"
                    :fields="fields2"
                    :items="data.UzexListByProvide"
                    bordered
                    sticky-header="60vh"
                    small
                    no-border-collapse
                  >
                    <template #cell(totalcost)="{item}">
                      {{
                        $options.filters.currency(item.totalcost, {
                          symbol: "",
                          fractionCount: 0
                        })
                      }}
                    </template>
                    <template #cell(sharepercent)="{item}">
                      <span> {{ item.sharepercent }} % </span>
                    </template>
                    <template #cell(provider_name)="{item}">
                      <a
                        href="javascript:void(0)"
                        @click="
                          $router.push({
                            name: 'ProviderCard',
                            query: {
                              providerid: 0,
                              providertin: item.provider_tin
                            }
                          })
                        "
                      >
                        {{ item.provider_name }}
                      </a>
                    </template>
                    <template v-slot:custom-foot>
                      <b-tr>
                        <b-td variant="info" class="text-center"
                          ><b> {{ $t("Total") }} : </b>
                        </b-td>
                        <b-td variant="info" class="text-right"
                          ><span style="white-space:nowrap;font-weight:bolder">
                            {{
                              $options.filters.currency(total.quantityAddress, {
                                symbol: "",
                                fractionCount: 0
                              })
                            }}
                          </span></b-td
                        >
                        <b-td variant="info" class="text-right"
                          ><span style="white-space:nowrap;font-weight:bolder">
                            {{
                              $options.filters.currency(total.sumAddress, {
                                symbol: "",
                                fractionCount: 0
                              })
                            }}
                          </span>
                        </b-td>
                      </b-tr>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('lotinfo')">
              <b-row class="mt-3">
                <b-col>
                  <b-table
                    head-row-variant="info"
                    :fields="fields3"
                    :items="data.UzexListByLotInfo"
                    bordered
                    sticky-header="60vh"
                    small
                    no-border-collapse
                  >
                    <template #cell(totalcost)="{item}">
                      <span style="white-space:nowrap">{{
                        $options.filters.currency(item.totalcost, {
                          symbol: "",
                          fractionCount: 0
                        })
                      }}</span>
                    </template>
                    <template #cell(amount)="{item}">
                      {{
                        $options.filters.currency(item.amount, {
                          symbol: "",
                          fractionCount: 0
                        })
                      }}
                    </template>

                    <template #cell(price)="{item}">
                      <span style="white-space:nowrap">
                        {{
                          $options.filters.currency(item.price, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span>
                    </template>
                    <template v-slot:custom-foot>
                      <b-tr>
                        <b-td variant="info" class="text-center" colspan="7"
                          ><b> {{ $t("Total") }} : </b>
                        </b-td>
                        <b-td variant="info" class="text-right"
                          ><span style="white-space:nowrap;font-weight:bolder">
                            {{
                              $options.filters.currency(total.quantityLot, {
                                symbol: "",
                                fractionCount: 0
                              })
                            }}
                          </span></b-td
                        >
                        <b-td variant="info"></b-td>
                        <b-td variant="info" class="text-right"
                          ><span style="white-space:nowrap;font-weight:bolder">
                            {{
                              $options.filters.currency(total.sumLot, {
                                symbol: "",
                                fractionCount: 0
                              })
                            }}
                          </span>
                        </b-td>
                      </b-tr>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab :title="$t('product')">
              <b-row class="mt-3">
                <b-col>
                  <b-table
                    head-row-variant="info"
                    :fields="fields4"
                    :items="data.UzexListByProduct"
                    bordered
                    sticky-header="60vh"
                    small
                    no-border-collapse
                  >
                    <template #cell(minprice)="{item}">
                      <span style="white-space:nowrap;text-align:right">
                        {{
                          $options.filters.currency(item.minprice, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span>
                    </template>
                    <template #cell(maxprice)="{item}">
                      <span style="white-space:nowrap;text-align:right">
                        {{
                          $options.filters.currency(item.maxprice, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import UzexService from "@/services/others/uzex.service";
export default {
  props: {
    buyerid: {},
    buyertin: {}
  },
  data() {
    return {
      fields1: [
        { key: "category_name", label: this.$t("category"), sortable: true },
        {
          key: "totalcount",
          label: this.$t("lotcount"),
          class: "text-right",
          sortable: true
        },
        {
          key: "totalcost",
          label: this.$t("totalcost"),
          class: "text-right",
          sortable: true
        }
      ],
      fields2: [
        { key: "provider_name", label: this.$t("provider"), sortable: true },
        {
          key: "lotcount",
          label: this.$t("lotcount"),
          class: "text-right",
          sortable: true
        },
        {
          key: "sharepercent",
          label: this.$t("sharepercent"),
          class: "text-right",
          sortable: true
        },
        {
          key: "totalcost",
          label: this.$t("totalcost"),
          class: "text-right",
          sortable: true
        }
      ],
      fields3: [
        { key: "lotid", label: this.$t("lotid"), sortable: true },
        { key: "lotdate", label: this.$t("lotdate"), sortable: true },
        { key: "oblastname", label: this.$t("oblast"), sortable: true },
        { key: "regionname", label: this.$t("region"), sortable: true },
        { key: "providername", label: this.$t("buyername"), sortable: true },
        { key: "categoryname", label: this.$t("category"), sortable: true },
        { key: "productname", label: this.$t("product"), sortable: true },
        {
          key: "amount",
          label: this.$t("amount"),
          class: "text-right",
          sortable: true
        },
        {
          key: "price",
          label: this.$t("price"),
          class: "text-right",
          sortable: true
        },
        {
          key: "totalcost",
          label: this.$t("totalcost"),
          class: "text-right",
          sortable: true
        }
      ],
      fields4: [
        { key: "product_name", label: this.$t("product"), sortable: true },
        {
          key: "minprice",
          label: this.$t("minprice"),
          class: "text-right",
          class: "text-right",
          sortable: true
        },
        {
          key: "maxprice",
          label: this.$t("maxprice"),
          class: "text-right",
          sortable: true
        }
      ],
      data: {},
      show: false,
      buyerInfo: {},
      total: {
        sumLot: 0,
        quantityLot: 0,
        quantityAddress: 0,
        sumAddress: 0,
        quantityCat: 0,
        sumCat: 0
      }
    };
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      this.show = true;
      UzexService.BuyerCard(this.buyerid, this.buyertin)
        .then(res => {
          this.data = res.data.result;
          this.buyerInfo = res.data.result.buyerInfo;
          this.show = false;
          this.calculateTotal();
        })
        .catch(error => {
          this.$notification(error.response.data.error, "danger");
          this.show = false;
        });
    },
    calculateTotal() {
      var self = this;
      self.total = {
        sumLot: 0,
        quantityLot: 0,
        quantityAddress: 0,
        sumAddress: 0,
        quantityCat: 0,
        sumCat: 0
      };
      self.data.UzexListByLotInfo.forEach(function(item) {
        self.total.sumLot += item.totalcost;
        self.total.quantityLot += item.amount;
      });
      self.data.UzexListByProvide.forEach(function(item) {
        self.total.sumAddress += item.totalcost;
        self.total.quantityAddress += item.lotcount;
      });
      self.data.UzexListByProductCategory.forEach(function(item) {
        self.total.sumCat += item.totalcost;
        self.total.quantityCat += item.totalcount;
      });
    }
  }
};
</script>

<style></style>
